import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { booksActions } from '../../../store/books';

// https://github.com/ashvin27/react-datatable
import ReactDatatable from '@ashvin27/react-datatable';

class Search extends React.Component {

    constructor(props) {
        super(props);

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            no_data_text: '데이터가 없습니다!',
            language: {
                length_menu: "보기_MENU_ 페이지 당 줄수",
                filter: "검색...",
                info: "_START_ ~ _END_ / 전체: _TOTAL_ ",
                pagination: {
                    first: "처음",
                    previous: "이전",
                    next: "다음",
                    last: "마지막"
                }
            },
            show_length_menu: false,
            show_filter: true,
            show_pagination: true,
            show_info: true,
            //sort: { column: "time", order: "desc" },            
            sort: {}
        }
        this.columns = [
            {
                key: "id",
                text: "번호",
                className: "text-center",
                align: "center",
                sortable: false,
                width: 60,
            },
            {
                key: "name",
                text: "제목",
            },
            {
                key: "author",
                text: "저자",
            },
            {
                key: "publish",
                text: "출판사",
            },
            {
                key: "reqno",
                text: "청구번호",
            },
        ];
    }

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
        this.props.getDictionary(this.props.location.pathname.split('/')[1], this.props.location.pathname.split('/')[2]);
    }

    render() {
        if (!this.props.books.books && this.props.books.length === 0) return null;
        //console.log(this.props.books);

        let endOfFixed = false;
        let books = this.props.books.books;
        let key = books.length;
        for (let i = 0; i < books.length; i++) {
            books[i].id = key--;                                     // id key  추가
            if (!books[i].fixed) endOfFixed = true;
            if (endOfFixed) books[i].fixed = false;              // trick for 공지/번호
        }

        return (
            <div className="container g-pt-0 g-pb-60">

                <ReactDatatable className="table table-hover g-brd-y g-brd-gray-light-v3-top"
                    config={this.config}
                    records={books}
                    columns={this.columns}
                />

            </div>
        )
    }
}

export default connect(
    state => state.books,
    dispatch => bindActionCreators({ ...booksActions }, dispatch)
)(withRouter(Search));


// WEBPACK FOOTER //
// ./src/pages/front/library/search.js